import { render, staticRenderFns } from "./new-pro-video.vue?vue&type=template&id=46d51474&scoped=true&"
import script from "./new-pro-video.vue?vue&type=script&lang=js&"
export * from "./new-pro-video.vue?vue&type=script&lang=js&"
import style0 from "./new-pro-video.vue?vue&type=style&index=0&id=46d51474&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d51474",
  null
  
)

export default component.exports